import { PropsWithChildren, useRef } from 'react';
import './LoginLayout.scss';

export const LoginLayout = ({ children }: PropsWithChildren) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const backgroundVideo = '/assets/login-background.mp4';

    const handleCanPlay = () => {
        videoRef.current?.classList.add('is-ready');
    };

    return (
        <div className="full-page-layout">
            {backgroundVideo && (
                <video
                    ref={videoRef}
                    className="full-page-layout__video"
                    src={backgroundVideo}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onCanPlay={handleCanPlay}
                />
            )}
            <div className="login-layout">
                <img
                    className="login-layout__logo"
                    alt="SteelBuy Logo"
                    src="/assets/lib-ui-primitive/images/steelbuy-logo-login_v2.svg"
                />
                {children}
            </div>
        </div>
    );
};
